import { put, call, takeLatest, select, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* favoriteMyListGet(action) {
  yield put(loadingSet(true));
  const res = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/favoriteMyListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "FAVORITE_MY_LIST_SET",
        payload: {
          count: res.data.count,
          list: res.data.list,
          page: action.payload.page,
          isList: res.data.isList,
          isListNext: res.data.isListNext,
          datetime: (new Date()),
        },
      });
    }
  }
  yield put(loadingSet(false));
}

function* favoriteMyAdd(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'add');
    params.append('pic', payload.pic);
    params.append('notice', payload.notice);
    return axios.post(config.apiUri + "member/favoriteMyEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield put(loadingSet(false));
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "TIMELINE_LIST_INIT",
      });
      yield put({
        type: "FAVORITE_MY_LIST_INIT",
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: 'お気に入りに登録しました'} });
      action.callback(res.data);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }

  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
}

function* favoriteMyDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/favoriteMyEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield put(loadingSet(false));
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "FAVORITE_MY_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "TIMELINE_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: 'お気に入りを解除しました'} });
    }
    action.callback();
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

}

function* favoritePartnerListGet(action) {
  const state = yield select();
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/favoritePartnerListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "FAVORITE_PARTNER_LIST_SET",
        payload: {
          list: res.data.list,
          page: action.payload.page,
          count: res.data.count,
          isList: res.data.isList,
          isListNext: res.data.isListNext,
          datetime: (new Date()),
        },
      });
      if (state.notification.favoriteNoticeUnconfirmed > 0) {
        yield delay(600);
        yield put({type: 'NOTIFICATION_GET'});
      }
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* favoritePartnerDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/favoritePartnerEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "FAVORITE_PARTNER_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: 'お気に入りを通知を削除しました'} });
    }
    action.callback();
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


const saga = [
  takeLatest('FAVORITE_MY_LIST_GET', favoriteMyListGet),
  takeLatest('FAVORITE_MY_ADD', favoriteMyAdd),
  takeLatest('FAVORITE_MY_DEL', favoriteMyDel),
  takeLatest('FAVORITE_PARTNER_LIST_GET', favoritePartnerListGet),
  takeLatest('FAVORITE_PARTNER_DEL', favoritePartnerDel),
];

export default saga;
